import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { Events, ModalController, Platform ,ToastController} from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { PricelistModalPage } from 'src/app/pricelist-modal/pricelist-modal.page';
import { ConfigService } from 'src/app/services/config/config.service';
import { LabelService } from 'src/app/services/label/label.service';
import { SharedService } from 'src/app/services/shared/shared.service';
import { IonSlides } from '@ionic/angular';
import { WidgetsService } from 'src/app/services/widgets/widgets.service';
import { Subscription } from 'rxjs';
import { CartService } from 'src/app/services/cart/cart.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { encodeURL } from 'src/app/services/parseURL';
import { ConsoleService } from 'src/app/services/console/console.service';
import { DesignStudioService } from 'src/app/services/design-studio/design-studio.service';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
    selector: 'app-widget-product-carousel',
    templateUrl: './widget-product-carousel.component.html',
    styleUrls: ['./widget-product-carousel.component.scss'],
})
export class WidgetProductCarouselComponent implements OnInit {

    @ViewChild('bestsellerslider', {
        static: false
    }) public bestsellerslider: IonSlides;

    bestSellerSlideOpts:any = {};
    useThumb: boolean;
    RFQFeature = false;
    SHARED_LABELS: any;
    @Input() cartProducts = [];
    @Input() role: string;
    @Input() userId: string;
    @Input() showPrices: any;
    @Input() widgetID: any;
    @Input() widgetTitle: any;
    @Input() productsData: any;
    currencyCode: any;
    products = [];
    noProducts = true;

    isPriceReq = false;
    isSubscriptionActive = false;
    subscriptionFeature = false;
    subCatId;
    subCatName;
    categoryId
    categoryName;
    cartSub: Subscription;
    priceForRetail = false;
    gridType = 'shop';
    widgetStyle:any;
    lgColClass;
    mdColClass;
    smColClass;
    designStudioActive;
    background:any ;
    segmentModel;
    widgetData;
    groups;
    activeGroup = 0;
    constructor(private platform: Platform,
        private utilsService:UtilsService,
        private sharedService: SharedService,
        private configService: ConfigService,
        private events: Events,
        private storage: Storage,
        private labelService: LabelService,
        private router: Router,
        private widgetsService: WidgetsService,
        private modalController: ModalController,
        private toastController:ToastController,
        private consoleService:ConsoleService,
        private designStudioService:DesignStudioService,
        private domSanitizer:DomSanitizer,
        
        private cartService: CartService) { }

    async ngOnInit() {
        this.RFQFeature = this.configService.environment.RFQFeature;
        this.currencyCode = this.configService.environment.currencyCode;
        this.subscriptionFeature = this.configService.environment.currencyCode;
        this.priceForRetail = this.configService.environment.priceForRetail;
        this.SHARED_LABELS = this.labelService.labels['SHARED'];
        this.cartProducts = this.cartService.getCartProducts();
        this.userId = await this.sharedService.getStorageUid();
        this.initializeSubscriptions();
        this.priceRequestFeature();

    }

    ngOnDestroy() {
        this.removeSubscriptions();
    }
   
    setActiveGroup(i){
        this.activeGroup = i;
    }

    isProductExistinGroup(id){
        if(this.groups && this.groups.length && this.groups[this.activeGroup].products.indexOf(id) >= 0){
            return true
        }
        else{
            return false
        }

    }

    async initializeSubscriptions() {
        this.designStudioActive = this.designStudioService.designStudioActive;
        let widgetData: any = await this.widgetsService.getWidgetData(this.widgetID);
        this.widgetData = widgetData;
        if(this.widgetData.groups){
            this.groups =  this.widgetData.groups;
        }
        if (widgetData) {
            
            if (widgetData && widgetData.style && Object.keys(widgetData.style).length != 0) {
                this.widgetStyle = widgetData.style;
                this.consoleService.consoleLog('widget-product-carousel:118 q   ', this.widgetStyle)
                if(this.widgetStyle.widgetStyle && this.widgetStyle.widgetStyle.backgroundImage){
                    this.background = this.domSanitizer.bypassSecurityTrustStyle(`url(${this.widgetStyle.widgetStyle.backgroundImage})`);
                }
                else if(this.widgetStyle.widgetStyle && this.widgetStyle.widgetStyle.backgroundColor){
                    this.background = this.widgetStyle.widgetStyle.backgroundColor;
                }
                else{
                    //this.background = 'transparent';
                }
            }
            else{
                this.widgetStyle = await this.designStudioService.getSessionStorageGlobalData();
            }
            this.setStyle();

        }

       

        this.cartSub = this.cartService.getCartProductsListener().subscribe((cartProducts) => {
            this.cartProducts = cartProducts;
        });

        this.events.subscribe('product-subscriptions:publishSettings', async (data) => {
            if (!this.isEmptyObj(data)) {
                this.subscriptionFeature = typeof data.isActive !== 'undefined' ? data.isActive : false;
            }
            if (this.subscriptionFeature) {
                this.events.publish('product-subscriptions:getSettings');
            }
        });

        if (this.widgetID) {
            let data: any = await this.widgetsService.getProductsForCarousel(this.widgetID);
            if(data && data.length){
                this.utilsService.consoleLog('carusel products', data);
                this.setProducts(data);
            }
        }

        if(this.productsData){
            this.utilsService.consoleLog('related products carusel products', this.productsData);
            this.setProducts(this.productsData);
        }
    }

    async setStyle(){
      
            let lgColClass = this.widgetStyle.productStyle.gridColumn.lg;
            let mdColClass = this.widgetStyle.productStyle.gridColumn.md;
            let smColClass = this.widgetStyle.productStyle.gridColumn.sm;
            this.bestSellerSlideOpts = {
                initialSlide: 1,
                speed: 1000,
                autoplay: false,
                spaceBetween: 20,
                slidesPerView:lgColClass,
                slidesPerGroup:lgColClass,
                breakpoints: {
            576: {
                slidesPerView: smColClass,
                slidesPerGroup:smColClass
            },
            1366: {
                slidesPerView: mdColClass,
                slidesPerGroup:mdColClass
            }
        }
            }

    }

    priceRequestFeature() {
        this.isPriceReq = this.configService.environment.priceReqFeature;
        if (this.isPriceReq) {
            this.storage.get('showPrices').then((val) => {
                this.showPrices = val;
                this.storage.get('userRole').then((role) => {
                    this.role = role;
                });
            });
        }
    }

    async setProducts(products) {
        if(products.length) {
            for (let product of products) {
                product = await this.prepareProductData(product.data);
                product = this.prepareProductForView(product);
            }
            this.products = products;
            this.noProducts = false;
        }
    }

    async prepareProductData(product: any) {
        const wishlistProducts = await this.storage.get('wishlistProducts');
        const subRole = await this.storage.get('userSubRole');
        const userId = await this.storage.get('uid');
        const data = {
            wishlistProducts,
            subRole,
            userId,
            product,
            cartProducts: this.cartProducts
        }
        const updatedProduct = await this.sharedService.prepareProductData(data);
        return updatedProduct;
    }

    prepareProductForView(item) {
        const newObj = {};
        const { id, cartQty, cartId, isWishlisted, ...data } = item;
        newObj['data'] = data;
        newObj['id'] = id;
        newObj['cartQty'] = cartQty;
        newObj['cartId'] = cartId;
        newObj['isWishlisted'] = isWishlisted;

        return newObj;
    }

    isEmptyObj(object) {
        for (const key in object) {
            if (object.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    isProductSubAvailable(product) {
        return this.subscriptionFeature && product.hasOwnProperty('subscription') && product.subscription.isAllowed ? true : false;
    }

    nextSlide() {
        this.bestsellerslider.slideNext();
    }
    prevSlide() {
        this.bestsellerslider.slidePrev();
    }



    async decrementQuantity(index: number) {
        if (this.products[index].cartQty > 1) {
          const res = await this.cartService.updateCartState(
            this.products[index].cartId,
            this.products[index].cartQty -1
          );
          if (!res) return;
          this.products[index].cartQty -= 1;
          this.products[index]["cartUpdateTimer"] =
            this.products[index]["cartUpdateTimer"] || null;
          clearTimeout(this.products[index]["cartUpdateTimer"]);
          this.products[index]["cartUpdateTimer"] = setTimeout(() => {
            this.cartService.updateCartProduct(
              this.products[index].cartId,
              this.products[index].cartQty
            );
          }, 800);
        } else {
          this.cartService.deleteCartProduct(this.products[index].cartId);
        }
      }
    
      async incrementQuantity(index: number) {
        const res = await this.cartService.updateCartState(
          this.products[index].cartId,
          this.products[index].cartQty +1
        );
        if (!res) return;
        this.products[index].cartQty += 1;
        this.products[index]["cartUpdateTimer"] =
          this.products[index]["cartUpdateTimer"] || null;
        clearTimeout(this.products[index]["cartUpdateTimer"]);
        this.products[index]["cartUpdateTimer"] = setTimeout(() => {
          this.cartService.updateCartProduct(
            this.products[index].cartId,
            this.products[index].cartQty
          );
        }, 800);
      }

    async addToCart(product: any, productID: any, index: number) {
        const isCartAvailable = await this.cartService.checkCartAvailability();
        if (isCartAvailable) {
            const cartObj = this.cartService.getCartObj(product, productID);
            const cartId = await this.cartService.addProductToCart(cartObj);
            this.products[index].cartQty = 1;
            this.products[index].cartId = cartId;
        }
    }

    async addProductToCart(index: number) {
        const product = this.products[index];
        const isCartAvailable = await this.cartService.checkCartAvailability(product.data.inactiveByVendor);
        if (isCartAvailable) {
            const cartObj = this.cartService.getCartObj(product.data, product.id);
            const cartId = await this.cartService.addProductToCart(cartObj);
            this.products[index].cartQty = 1;
            this.products[index].cartId = cartId;
        }
    }




    removeHtml(desc) {
        const tagsRemoved = desc.replace(/(<([^>]+)>)/ig, '');
        const plainTxt = document.createElement('textarea');
        plainTxt.innerHTML = tagsRemoved;
        return plainTxt.value;
    }

    
    async priceListAddToCart(product) {
        const isCartAvailable = await this.cartService.checkCartAvailability();
        if (isCartAvailable) {
            let listOfWeights = [];
            for (let i = 0; i < product.data.priceList.length; i++) {
                listOfWeights.push(product.data.priceList[i].weight);
            }
            product.data.priceList.map((entry) => {
                entry.quantity = 0;
                //entry.cartLoader = false;
            });
            this.modalController.create({
                component: PricelistModalPage,
                cssClass: 'custom-modal',
                componentProps: {
                    product: product,
                    listOfWeights: listOfWeights,
                    cartProducts: this.cartProducts
                }
            })
                .then(modalEl => {
                    modalEl.present();
                });
        }

    }
    getDiscountedProduct(price, discount) {
        let discountedPrice = Math.ceil(price - (price * ((discount * 1) / 100)));
        return discountedPrice;
    }



    maxQtyReached() {
        this.sharedService.presentToast(`${this.SHARED_LABELS['max_quantity_reach_msg']}`);
    }

    getDiscountPercent(discountedPrice, prodPrice) {
        if (prodPrice > discountedPrice) {
            let discount = Math.round(((prodPrice - discountedPrice) / prodPrice) * 100);
            return discount;
        } else {
            return 0;
        }
    }

    getPriceListDiscountPercent(priceList) {
        if(priceList && priceList.length) {
            const plDiscountList = [];
            priceList.forEach(pl => {
                const plDiscount = ((pl.price - pl.discountedPrice) / pl.price) * 100;
                plDiscountList.push(plDiscount);
            });
            return parseFloat((Math.max(...plDiscountList)).toFixed(2));
        } else {
            return 0;
        }
    }

    checkPdtStock(pdt) {
        let isOutOfStock = false;
        if (!pdt.isPriceList) {
            if (pdt.productQty === '0' && pdt.stopWhenNoQty) {
                isOutOfStock = true;
            }
        } else {
            if (pdt.stopWhenNoQty) {
                for (let pl of pdt.priceList) {
                    if (pl.totalQuantity !== '0') {
                        isOutOfStock = false;
                        break;
                    } else {
                        isOutOfStock = true;
                    }
                }
            }
        }
        return isOutOfStock;
    }

    urlPdtName(pname: string) {
        return encodeURL(pname);
    }

    removeSubscriptions() {
        this.events.unsubscribe('product-subscriptions:publishSettings');

        this.cartSub.unsubscribe();
    }

    clickProduct(prodName, prodID) {
        let productName = encodeURL(prodName);
        this.router.navigate([`product-details/${productName}/${prodID}`]);

    }

    isProductInCart(product) {
        return this.cartService.isProductInCart(product)
    }

    async openPriceModal(index: number) {
        const product = this.products[index];
        let listOfWeights = [];
        for (let i = 0; i < product.data.priceList.length; i++) {
            listOfWeights.push(product.data.priceList[i].weight);
        }
        product.data.priceList.map((entry) => {
            entry.quantity = 0;
            //entry.cartLoader = false;
        });
        const productURL = this.getProductRouteUrl(product.data.prodName, product.id);
        this.modalController.create({
            component: PricelistModalPage,
            cssClass: 'price-list-modal',
            componentProps: {
                product: product,
                listOfWeights: listOfWeights,
                cartProducts: this.cartProducts,
                productURL
            }
        }).then(modalEl => {
                modalEl.present();
        });
    }

    getProductRouteUrl(productName: string, productID: string) {
        return `product-details/${this.urlPdtName(productName)}/${productID}`;
    }

    goToProduct(index: number) {
        // const prodName = this.products[index].data.prodName;
        // const prodID = this.products[index].id;
        // this.router.navigate([this.getProductRouteUrl(prodName, prodID)]);

        const product = this.products[index].data;
        const productId = this.products[index].id;
        if (product.ptype === 'child') {
            this.router.navigate([`product-details/${encodeURL(product.prodName)}/${product.parentId}/option/${product.objectID}`]);
        } else {
            this.router.navigate([`product-details/${encodeURL(product.prodName)}/${productId}`]);
        }
    }

    async heartClicked(i: number) {
        const pid = this.products[i].id;
        const res = await this.sharedService.checkLoginStatus(`${this.SHARED_LABELS['must_be_user_to_use_wishlisht_msg']}`);
        if (res) {
            const isWishlisted = this.products[i].isWishlisted;
            if (!isWishlisted) {
                this.events.publish('wishlist:heartClicked', pid, 'not_in_list', i);
                this.products[i].isWishlisted = true;
                this.presentToast(`${this.SHARED_LABELS['item_added_to_wishlist_msg']}`, 'success');
            } else {
                this.events.publish('wishlist:heartClicked', pid, 'in_list', i);
                this.products[i].isWishlisted = false;
                this.presentToast(`${this.SHARED_LABELS['item_removed_from_wishlist_msg']}`, 'danger');
            }
        }
    }

    async deleteWishlistPdt(i: number) {
        const pid = this.products[i].id;
        await this.sharedService.presentLoading(5000);
        this.sharedService
        this.events.publish('wishlist:deleteProduct', pid, i);
        this.products.splice(i, 1);
        if (this.sharedService.loading) {
            this.sharedService.loading.dismiss();
        }
        this.presentToast(`${this.SHARED_LABELS['item_removed_from_wishlist_msg']}`, 'danger');
    }

    async presentToast(msg: string, clr) {
        const toast = await this.toastController.create({
            message: msg,
            duration: 2000,
            position: 'top',
            color: clr

        });
        toast.present();
    }

    async priceListFirstToCart(index: number) {
        const product = this.products[index];
        const isCartAvailable = await this.cartService.checkCartAvailability();
        if (isCartAvailable) {
            const cartObj = this.cartService.getPriceListCartObj(product);
            const cartId = await this.cartService.addProductToCart(cartObj);
            this.products[index].cartQty = 1;
            this.products[index].cartId = cartId;
        }
    }

    segmentChanged(event){
        console.log(this.segmentModel);
        
        console.log(event);
      }

}

